export enum AttributeDefinitionType {
  MainField = 'customFields',
  SubField = 'subFields',
}
